var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{staticStyle:{"width":"100%","height":"24rem"},attrs:{"zoom":6,"center":{ lat: -37.78, lng: 175.25 },"options":{
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false
  }}},_vm._l((this.trackers),function(tracker,index){return _c('Gmap-Marker',{key:tracker.id,attrs:{"position":{ lat: tracker.lat, lng: tracker.lng},"options":{ fillColor: 'orange'}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports